export default __webpack_public_path__ + "static/media/angular.8f069a35.svg";